export default "__VITE_ASSET__kPlj$LX5__"